import { Link } from "react-router-dom";
import { AssistantSurface } from "../components/assistant/AssistantSurface";
import { useAssistantAccess } from "../hooks/useAssistantAccess";

/**
 * The assistant as a full page: top bar, transcript, composer pinned to the bottom.
 *
 * This is the model-comparison surface, limited to the named testers while the
 * evaluation runs. Everyone else keeps the assistant on the home page, unchanged —
 * the gate withholds the evaluation, not the assistant.
 */
export default function Assistant() {
  const { canCompareModels, isLoading } = useAssistantAccess();

  if (isLoading) {
    return (
      <main className="flex flex-1 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-maven-gray-100 dark:border-maven-gray-800 border-t-maven-teal-500" />
      </main>
    );
  }

  if (!canCompareModels) {
    return (
      <main className="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
        <h1 className="text-lg font-medium text-maven-gray-800 dark:text-maven-gray-100">Not available yet</h1>
        <p className="max-w-md text-sm text-maven-gray-500 dark:text-maven-gray-500">
          This page is a working surface for evaluating assistant models, open to a small
          group while that runs. The assistant itself is on the home page and works as usual.
        </p>
        <Link to="/" className="text-sm text-maven-teal-700 hover:underline">
          Back to home
        </Link>
      </main>
    );
  }

  return (
    <main className="flex min-h-0 flex-1 flex-col bg-maven-gray-100 dark:bg-maven-gray-800">
      <AssistantSurface enableComparison />
    </main>
  );
}
